import { useSearchParams } from "react-router";
import { useTranslation } from "react-i18next";

export const useRedirectUrl = () => {
  const [parameters] = useSearchParams();
  const { i18n } = useTranslation();
  const redirect = parameters.get("redirect");
  const redirectUrl = window.location.href.includes("utlogget")
    ? `redirect=${redirect}`
    : `redirect=${window.location.href}`;
  const lang = `locale=${i18n.language}`;
  const urlTilInnlogging = `/oauth2/login?${lang}&${redirectUrl}`;
  return { urlTilInnlogging };
};
